<template>
    <b-modal v-model="error" ref="error-modal" @hide="returnToLobby" hide-footer :title="$t('ERRORS_DETECTED')">
        <b-container>
                    <b-row>
                        <b-col cols="10"
                               class="align-left">
                            <ul id="errorsList">
                                <li v-show="showErrors" v-for="(error,index) in errorMessages">
                                    {{ error }}
                                </li>
                                <li v-show="showHtml">
                                    <span v-html="htmlContent"></span>
                                </li>
                            </ul>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="9">
                        </b-col>
                        <b-col cols="3">
                            <b-button class="btn btn-primary btn-lg btn-margin-narrow-aligned-right float-right make-space-above"
                                      title="Close"
                                      aria-label="Return to Lobby"
                                      @click="returnToLobby">
                                {{buttonText}}
                            </b-button>
                        </b-col>
                    </b-row>
        </b-container>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Repo from '../repo';
    import i18n from '../localization';

    export default {
        name: 'Error',
        computed: {
        ...mapGetters({
            errorMessages: 'shell/errorMessages',
            anyErrors: 'shell/anyErrors',
            htmlContent: 'shell/htmlContent',
            error: 'error'
            }),
        error: {
           get(){
             return this.anyErrors || this.showHtml
           },
            set(value) {
                this.$store.dispatch("shell/clearErrorMessages");
                return value;
           } 
            },
            showHtml() {
                return this.htmlContent !== '';
            },
            showErrors() {
                return this.anyErrors;
            },
            buttonText() {
                var url = window.location.href;
                return url.includes("donation") ? i18n.t('RETURN_TO_AMBIT_CARES') : i18n.t('CLOSE');
            }
    },
        methods: {
            returnToLobby() {
                var url = window.location.href;
                if (url.includes("donation")) {
                    this.returnToAmbitCares();
                } else if (url.includes("bluenet")){
                    this.$router.push("/");
                } else {
                    this.$store.dispatch('shell/clearErrorMessages');
                }
            },
            returnToAmbitCares() {
                Repo.DonationService.ReturnToAmbitCares();
            }

        }

    }

</script>

